var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('base-page',[_c('notary-product-list',_vm._b({on:{"new-product":_vm.gotoQuestionnaire}},'notary-product-list',_vm.$props,false))],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }